import $ from 'jquery';
import datepicker from 'jquery-ui/ui/widgets/datepicker';

var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

// Which weekday is currently the anchor. Null until the first sync, which is what keeps a
// re-rendered form intact: after a validation error the server sends the admin's ticked
// days back, and there is no anchor to retire yet.
var lastAnchorDay = null;

// The start date's own weekday is always part of the pattern and can't be unticked: a
// series that skips its own start day can generate zero occurrences. Keep that day ticked
// and disabled, and mirror it into the hidden field, since a disabled checkbox submits
// nothing. No hidden field means a saved event, where the whole pattern is locked.
function syncAnchorDay(weekDay) {
  var $anchor = $('#event_repeat_days_of_week_anchor');
  if ($anchor.length === 0 || isNaN(weekDay)) return;

  $anchor.val(DAY_NAMES[weekDay]);
  $('.repeat-day-js').each(function (index) {
    var isAnchor = index === weekDay;

    $(this).prop('disabled', isAnchor);
    if (isAnchor) $(this).prop('checked', true);
  });

  // Moving the start date leaves the day that used to be the anchor behind, ticked because
  // it was the start day rather than because anyone chose it. Retire exactly that one, so
  // the pattern doesn't quietly grow a day the admin never asked for - and so the days they
  // did tick, here or on a previous render, are left alone.
  if (lastAnchorDay !== null && lastAnchorDay !== weekDay) {
    var $retired = $('.repeat-day-js').eq(lastAnchorDay);
    if (!$retired.data('userPicked')) $retired.prop('checked', false);
  }

  lastAnchorDay = weekDay;
}

// "Never" and "Every day" don't take a weekday set, and the model rejects one. Untick
// whatever is showing before hiding the picker, or a frequency change after ticking days
// submits them anyway and fails validation.
function toggleRepeatDays(repeatSelection) {
  var takesDays = repeatSelection === 'Every Week' || repeatSelection === 'Every 2 Weeks';

  $('.repeat-days-js').toggleClass('d-none', !takesDays);
  // Clear userPicked along with the box. Leaving it set means a day the admin cleared here
  // survives syncAnchorDay's retire branch later - it would be kept as a deliberate choice
  // and quietly rejoin the pattern.
  if (!takesDays) $('.repeat-day-js:not(:disabled)').prop('checked', false).data('userPicked', false);
  // The hidden anchor submits regardless of what the checkboxes are doing, and a weekday
  // set on "Never" or "Every day" is a validation error. Disabled inputs aren't submitted.
  $('#event_repeat_days_of_week_anchor').prop('disabled', !takesDays);

  return takesDays;
}

$(document).on('turbo:load', function() {
  $(function(){
    $('select#event_repeat_freq, input#event_date_string, input#event_end_date_string').on('change', function () {
      var startDateString = $("input#event_date_string").val(); //Ex: 10/31/2021
      var startDate = new Date(startDateString); //Ex: Sun Oct 31 2021 00:00:00 GMT-0700 (Pacific Daylight Time)

      var endDateString = $("input#event_end_date_string").val(); //Ex:  10/30/2022
      var endDate = new Date(endDateString); //Ex: Sun Oct 30 2022 00:00:00 GMT-0700 (Pacific Daylight Time)
      var weekDay = startDate.getDay(); // Sunday - Saturday : 0 - 6
      var repeatSelection = $('select#event_repeat_freq').children(':selected').text(); // ex: "Never"
      var week_of_the_year = datepicker.iso8601Week(startDate) // ex: 43
      var odd_or_even = week_of_the_year % 2; // 1 --> odd, 0 --> even

      syncAnchorDay(weekDay);
      // More than the start weekday ticked means occurrences land on several weekdays, so
      // the end date needn't fall on one of them - see the datepicker branches below.
      var multiDay = toggleRepeatDays(repeatSelection) && $('.repeat-day-js:checked').length > 1;

      var endingDate = (startDate > endDate) ? startDate : endDate; // Sun Oct 30 2022 00:00:00 GMT-0700 (Pacific Daylight Time)
      var endingDateString = endingDate.toLocaleDateString(); // ex: 10/30/2022
      var todayDate = new Date() // Fri Oct 28 2022 19:45:50 GMT-0700 (Pacific Daylight Time)

      // handle 'start time'
      const beginningOfToday = todayDate.setHours(0, 0, 0, 0) //Ex: 1666940400000
      const startTime = startDate.setHours(0, 0, 0, 0) //Ex: 1635663600000
      var startTimeString = new Date(startTime).toLocaleDateString()

      if (startTime >= beginningOfToday) {
        $("input#event_date_string").datepicker({
          minDate: todayDate,
          defaultDate: startTimeString,
        });
      } else {
        $("input#event_date_string").attr("disabled", true)
      }

      // Handle end time
      // recalculate start date
      var startDateString = $("input#event_date_string").val();
      var startDate = new Date(startDateString);

      $("input#event_end_date_string").val(endingDateString)
      $('.toggle_visibility_js').removeClass('d-none').addClass('d-flex');

      var endDateSettings = {
        minDate: (startDate > todayDate) ? startDate : endDate,
        defaultDate: endingDateString
      }

      // Do not display 'End Date' at all
      if(repeatSelection == "Never") {
        $('.toggle_visibility_js').addClass('d-none').removeClass('d-flex');

      } else if (multiDay) {
        var showTheseDays = {
          // Several weekdays in play. Which dates are actually occurrences is a
          // Monday-anchored phase calculation that lives in RecurrenceRule; duplicating it
          // here would be a second implementation with no shared test, and it isn't needed
          // - the end date only bounds the series, it needn't land on an occurrence.
          beforeShowDay: function (date) { return [true, ''] }
        }

      } else if (repeatSelection == "Every Week") {
        var showTheseDays = {
          // Display only one day of the week
          beforeShowDay: function (date) { return [date.getDay() == weekDay, ""] }
        };

      } else if (repeatSelection == "Every 2 Weeks"){
        var showTheseDays = {
          // Display only one day of the week, every other week
          beforeShowDay: function(date){
          if (date.getDay() == weekDay && datepicker.iso8601Week(new Date(date)) % 2 == odd_or_even) {
                return [true, ''];
            } else {
                return [false, ''];
            }
          }
        }
      } else {
        var showTheseDays = {
          // Display every day of the week
          beforeShowDay: function(date) { return [true, ''] }
        }
      }

      let datepicker_options = { ...endDateSettings, ...showTheseDays }
      if ($("input#event_end_date_string.hasDatepicker").length == 0) {
        $("input#event_end_date_string").datepicker(datepicker_options);
      } else {
        $("input#event_end_date_string").datepicker("option", datepicker_options);
        $("input#event_end_date_string").datepicker("refresh");
      }
    });

    // Anything the server rendered ticked that isn't the anchor was chosen deliberately -
    // on a re-render after a validation error, that's the admin's own selection coming
    // back. Seed it, or a date change that passes through one of those days would absorb
    // it as the anchor and then retire it on the way out.
    $('.repeat-day-js').each(function () {
      if (this.checked && !this.disabled) $(this).data('userPicked', true);
    });

    $('select#event_repeat_freq, input#event_date_string, input#event_end_date_string').trigger('change');

    $('.repeat-day-js').on('change', function () {
      $(this).data('userPicked', this.checked);
      $('select#event_repeat_freq').trigger('change');
    });

    $('#end-class-now').on('change', function() {
      if (this.checked) {
        $('#past-date-warning').removeClass("d-none")
        $("input.forever-js:checkbox").prop("checked", false)
      }
      else {
        $('#past-date-warning').addClass("d-none")
        $('select#event_repeat_freq, input#event_date_string, input#event_end_date_string').trigger('change');
        $(".end_date_js").removeClass("d-none");
      }
    })

    function toggle_field() {
      if ($("input.forever-js:checkbox").is(':checked')) {
        $(".end_date_js").addClass("d-none");
        $("#end-class-now").prop("checked", false);
        $("#past-date-warning").addClass("d-none")
      } else {
        $('select#event_repeat_freq, input#event_date_string, input#event_end_date_string').trigger('change');
        $(".end_date_js").removeClass("d-none");
      }
    }
    toggle_field();
    $("input.forever-js:checkbox").on("change", function (e) {
      toggle_field();
    });

    // The series form asks the end-date question as one radio group instead. Runs after
    // toggle_field, whose no-checkbox branch would otherwise leave the date input shown.
    function toggleEndMode() {
      var mode = $("input[name=end_mode]:checked").val();
      if (!mode) return;
      $(".end_date_js").toggleClass("d-none", mode !== "on_date");
      $("#past-date-warning").toggleClass("d-none", mode !== "after_last");
    }
    toggleEndMode();
    $("input[name=end_mode]").on("change", toggleEndMode);
  });
});
